import $ from 'jquery';

//Action to show eye on password show
$('body').on('click', '.show-pw', function (e) {
  $(this).toggleClass('fa-eye');
  $(this).toggleClass('fa-eye-slash');
});

//################  DATATABLE ################
//Action to reload table
$('body').on('click', '.reloadTableButton', function (e) {
  let tableId = $(this).attr('dataTableId');
  reloadTable(tableId);
});

function reloadTable(tableId) {
  $('#' + tableId)
    .DataTable()
    .ajax.reload(false, false);
}
window.reloadTable = reloadTable;

//show animation on button click of data table loader
$(document).on('processing.dt', 'table', function (e, settings, processing) {
  if (processing) {
    if (!$('.reload-table i').hasClass('fa-spin')) {
      $('.reload-table i').addClass('fa-spin');
      $('.reload-table').removeClass('btn-outline-secondary');
      $('.reload-table').addClass('btn-outline-primary');
    }
  } else {
    $('.reload-table').removeClass('btn-outline-primary');
    $('.reload-table').addClass('btn-outline-secondary');
    $('.reload-table i').removeClass('fa-spin');
  }
});
